module.exports = __webpack_public_path__ + "img/Ulnar-sidedwristpain.6fd90643.gif";